import React from 'react';
import './App.css';
import ImageSwiper from './ImageSwiper';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1 id="Header">Gallery</h1>
        <ImageSwiper />
      </header>
    </div>
  );
}

export default App;